import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../service/Interceptor";
import {
  getReceivedEmailListAPI,
  getRequestEmailListAPI,
} from "../service/apiUrl";
import toast from "../components/Toast/toast";

const initialState = {
  sentEmailRequestList: [],
  receivedEmailRequestList: [],
  isLoading: false,
  hasError: false,
};

export const sentEmailRequest = createAsyncThunk(
  "sent-email-request",
  async (userId, thunkAPI) => {
    try {
      const res = await API.post(`api/users/${userId}/connections`);

      if (res?.data?.success) {
        console.log("From sentEmail request thunk", res);
        toast.success(res?.data?.message || "Connection send successfully");
        return res?.data?.data;
      } else {
        toast.error(
          res?.data?.message || "An error occurred in sending email request"
        );
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in requesting email"
        );
      }
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(
        error.response?.data || "Unknown error occurred"
      );
    }
  }
);

export const getRequestedEmailList = createAsyncThunk(
  "get-requestedEmail-details",
  async (params, thunkAPI) => {
    try {
      const res = await API.get(getRequestEmailListAPI, { params });
      if (res?.data?.success) {
        return res?.data?.data?.results;
      } else {
        console.log(
          res?.data?.message || "Error in getting request email list"
        );
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in requesting email list"
        );
      }
    } catch (error) {
      console.log("Error in getting an request email list", error);
      return thunkAPI.rejectWithValue(
        "Something went wrong in getting rquested email list"
      );
    }
  }
);

export const getReceivedEmailList = createAsyncThunk(
  "get-receivedEmail-details",
  async (params, thunkAPI) => {
    try {
      const res = await API.get(getReceivedEmailListAPI);
      if (res?.data?.success) {
        return res?.data?.data?.results;
      } else {
        console.log(
          res?.data?.message || "Error in getting received email request list"
        );
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in getting received email request"
        );
      }
    } catch (error) {
      console.log(
        "Something wrong Error in getting received email request",
        error
      );
      return thunkAPI.rejectWithValue(
        "Something went wrong in fetching email request we received"
      );
    }
  }
);

export const acceptOrRejectEmailRequest = createAsyncThunk(
  "acceptOrReject-email-request",
  async (payload, thunkAPI) => {
    const { userAliasId, status } = payload;
    try {
      const res = await API.post(`/api/users/connections/status`, undefined, {
        params: payload,
      });
      if (res?.data?.success) {
        toast.success(res?.data?.message || "success");
        return { data: res?.data?.data, userAliasId, status };
      } else {
        console.log(res?.data?.message || "Error in accepting request");
        toast.error(res?.data?.message || "Error in accepting or rejecting");
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in accepting email"
        );
      }
    } catch (error) {
      console.log("Error in Following an user", error);
      return thunkAPI.rejectWithValue(
        "Something went wrong accepting or rejecting email request"
      );
    }
  }
);

export const deleteEmailRequest = createAsyncThunk(
  "delete-email-request",
  async (params, thunkAPI) => {
    const { userId } = params;
    try {
      const res = await API.delete(`api/users/${userId}/connections`);
      if (res?.data?.success) {
        return res?.data?.data;
      } else {
        console.log(res?.data?.message || "Error in deleting request");
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in deleting email request"
        );
      }
    } catch (error) {
      console.log("Error in deleting an email request", error);
      return thunkAPI.rejectWithValue(
        "Something went wrong in deleting email request"
      );
    }
  }
);

const requestEmailSlice = createSlice({
  name: "emailRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //---------------------sent request email ---------------------
      .addCase(sentEmailRequest.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(sentEmailRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(sentEmailRequest.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      })
      //---------------------GET requested email list---------------------
      .addCase(getRequestedEmailList.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getRequestedEmailList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.sentEmailRequestList = action.payload;
      })
      .addCase(getRequestedEmailList.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      })
      //---------------------GET received email list---------------------
      .addCase(getReceivedEmailList.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getReceivedEmailList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.receivedEmailRequestList = action.payload;
      })
      .addCase(getReceivedEmailList.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      })
      //---------------------Accept or Reject email request---------------------
      .addCase(acceptOrRejectEmailRequest.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(acceptOrRejectEmailRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        // const index = state.receivedEmailRequestList.findIndex((list) => {
        //   return list.userAliasId === action.payload.userAliasId;
        // });
        // state.receivedEmailRequestList[index].status = action.payload.status;
      })
      .addCase(acceptOrRejectEmailRequest.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
        // state.otherUserProfile
      })
      //---------------------Delete email request ---------------------
      .addCase(deleteEmailRequest.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(deleteEmailRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
      })
      .addCase(deleteEmailRequest.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      });
  },
});

export default requestEmailSlice.reducer;
